import { render, staticRenderFns } from "./DepositDetailDialog.vue?vue&type=template&id=47f42d51"
import script from "./DepositDetailDialog.vue?vue&type=script&lang=js"
export * from "./DepositDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DepositDetailDialog.vue?vue&type=style&index=0&id=47f42d51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports